import logo from './logo.svg';
import svgBolt from './images/bolt-solid.svg';
import svgCard from './images/card-regular.svg';
import svgCompass from './images/compass.svg';
import svgGem from './images/gem-regular.svg';
import svgGlasses from './images/glasses-solid.svg';
import svgSpider from './images/spider-solid.svg';
import svgQuote from './images/iconquote.svg'
import jpgWald from './images/wald.jpg';
import jpgNeuronen from './images/neuronen.jpg';
import jpgBrain from './images/brain_alt.jpg';
import jpgChange from './images/change.jpg';
import jpgPortrait from './images/portrait.jpg';
import pngBurnout from './images/burnout.png';
import jpgBlue from './images/bg_01.jpg';
import jpgPraxis2 from './images/praxis_wennigsen_02.jpg';
import jpgSupervision from './images/supervision.jpg';
import bgQuote01 from './images/splotch02.jpg';
import bgQuote02 from './images/splotch01.jpg';
import bgQuote03 from './images/splotch03.jpg';
import gpt01 from './images/gpt_platzhalter_01.png';
import gpt02 from './images/gpt_platzhalter_02.png';
import svgLogoBlack from './images/logo_black.svg';
import svgLogoWhite from './images/logo_white.svg';
import lottieLinie from './images/struktur.json';
import Contactform from './contactform';
import React, { useEffect, useState } from 'react'
import Footer from './footer';
import Lottie from 'lottie-react';
import { Parallax, Background} from 'react-parallax';
import Menu from './menu';
import {HL,Section,SectionBody,Headline,Blog,BlogPost, Hero,HeroTextSpan,H1,P,CTA,Button,HeroImageSpan,Benefits, Benefit, BenefitIcon, Icon10, BenefitText, H2,P2, QuoteBg,QuoteWrapper,QuoteText,QuoteName,QuoteTitel,QuoteSeperator}  from "./home_style";
import { Container } from 'postcss';

import { motion } from 'framer-motion'


function ParallaxImage({ src, speed = 0.5, className = '' }) {
  const [scrollPosition, setScrollPosition] = useState(0)
  
  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.pageYOffset)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  
  return (
    <div className={`overflow-hidden ${className}`}>
      <motion.img 
        src={src} 
        alt="Parallax" 
        style={{ 
          y: scrollPosition * speed * -0.5,
          transition: 'none'
        }}
        className="w-full h-full object-cover scale-110"
      />
    </div>
  )
}

function Home() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieLinie,
    renderer: 'canvas',

    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  
  return (
    
<div>

  <Menu/>

  <Parallax bgImage={jpgBlue} strength={300} bgImageStyle={{ objectFit: 'cover' }}>
    <Background >
      <div className="w-screen sm:w-screen flex flex-wrap  mx-auto justify-center xl:justify-end opacity-50 h-screen self-center pt-64 sm:pt-0">
      <Lottie animationData={lottieLinie} loop={true} style={{width: '100%', height: '100%'}} />
      </div>
    </Background>

    <Section>
      <div className="h-28"></div>
        <Hero>
          <HeroTextSpan $Right>
            <H1 $Purple >bewegen, entwickeln <br/>verbinden & ankommen</H1>
              <P> </P>
            <CTA>
              
            </CTA>
          </HeroTextSpan>
          <HeroImageSpan className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          </HeroImageSpan>
        </Hero>
    </Section>

  </Parallax>




  <Section $greyBg>
  
  <SectionBody>

    <BlogPost className="text-justify w-full mb-12">
        <H1 $Center>Krise = <HL>Chance</HL><br/> Das <HL>A&O</HL> im Coaching</H1>
        <P $Blog>Veränderungen fallen Menschen von Natur aus nicht leicht. Wir haben ein großes Bedürfnis nach Kontinuität. Sie gibt uns Sicherheit.
        Blockaden, in Form von Krisen, Ängsten und Stress werden als unangenehm, anstrengend und herausfordernd erlebt. Sie trennen uns von unserer Kreativität, 
        unseren Ressourcen und vielem, was uns sonst ausmacht. Sie nehmen uns in manchen Situationen die Orientierung und lassen uns ratlos zurück.</P>
<P $Blog>Am besten, es gäbe sie nicht! Oder?</P>
<P $Blog>Doch so unangenehm diese Gefühle auch sind: Oft sind sie die treibende Kraft, die zur Veränderung und Entwicklung bewegt!
Aus den Zeiten, in denen wir vom Schicksal herausgefordert werden, können (r)evolutionäre Veränderungen erwachsen.
 Auch wenn es nicht leicht fällt: Die bewusste 
Auseinandersetzung mit sich und dem eigenen Leben in Krisenzeiten lohnt sich! Dabei unterstütze ich Sie gerne!</P>    

    </BlogPost>

    <QuoteBg style={{backgroundImage: 'url('+bgQuote02+')',backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}}>
      <QuoteWrapper >
        <QuoteText>»Die wesentliche Voraussetzung für Dein Glück ist die Bereitschaft der zu sein, der Du wirklich bist.«</QuoteText>
          <QuoteSeperator ></QuoteSeperator><QuoteName>Erasmus von Rotterdam</QuoteName><QuoteTitel>Theologe</QuoteTitel>
      </QuoteWrapper>
    </QuoteBg>

  </SectionBody>
</Section>
<Section>
  <SectionBody>

    <BlogPost className="text-justify w-full mb-12">
        <H1 $Center>Blockaden <HL>lösen</HL> und Ressourcen <HL>stärken</HL></H1>
        <P $Blog>Mit meinem Coaching unterstütze ich Sie dabei, Blockaden in Form von Krisen, Ängsten und Stress zu lösen und zu verwandeln. Die Stärkung Ihrer Verbindung zu sich selbst, eine persönliche Entwicklung und inneres Wachstum sind Ressourcen für Ihren weiteren Weg.
        <br/>Dafür nutze ich wirkungsvolle und wissenschaftlich fundierte Methoden. Melden Sie sich gerne!</P>
    </BlogPost>
    <CTA $Right>
        <Button $Second>Kontakt</Button>
    </CTA>

  </SectionBody>
</Section>

<Parallax bgImage={jpgChange} strength={400} bgImageStyle={{ objectFit: 'cover' }}>

      <Section>
      <div className="h-28"></div>
        <Hero>
          <HeroTextSpan $Right>
            <H1 $White ></H1>
              <P> </P>
            <CTA>
              
            </CTA>
          </HeroTextSpan>
          <HeroImageSpan className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          </HeroImageSpan>
        </Hero>
    </Section>

</Parallax>

<Section $greyBg>
  <SectionBody>

    <BlogPost className="text-justify w-full mb-12">
      <H1 $Center>Mein <HL>Verständnis</HL> von Coaching</H1>
        <P $Blog>Ein Tier läuft im Zoo in seinem Gehege entlang der Gitterstäbe auf und ab. Es ist dort geboren worden und hat in seinem Leben nie die Wildnis gesehen. Instinktiv weiß es, dass es mehr gibt als nur das Gehege: Seine Freiheit, in der es das nutzen kann, was in ihm angelegt ist.</P>
        <P $Blog>Kennen Sie dieses Gefühl?</P>
        <P $Blog>Coaching ist für mich Hilfe zur Selbsthilfe: Der Experte für Ihre Bedürfnisse und Ziele sind Sie. In Ihnen ist alles, was Sie für Ihren Prozess brauchen, auch wenn Ihnen das nicht immer bewusst ist.</P>
    </BlogPost>

    <QuoteBg style={{backgroundImage: 'url('+bgQuote01+')',backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}}>
      <QuoteWrapper >
        <QuoteText>»Man kann einen Menschen nichts lehren. Man kann ihm nur helfen es in sich selbst zu entdecken.«</QuoteText>
          <QuoteSeperator ></QuoteSeperator><QuoteName>Galileo Galilei</QuoteName><QuoteTitel></QuoteTitel>
      </QuoteWrapper>
    </QuoteBg>

  </SectionBody>
</Section>

<Section>
  <SectionBody>
    <BlogPost className="text-justify w-full mb-12">
      <H1 $Center>Effektiv, schnell, wirksam</H1>
        <P $Blog>In meiner Rolle als Coach unterstütze ich Sie dabei, Lösungen zu finden. Es geht darum, Blockaden zu lösen und sich Ihre Ressourcen wieder bewusst zu machen, sie zu aktivieren und zu stärken. Ich verstehe es als meine Aufgabe, Ihren individuellen Weg zum Ziel, schnell und nachhaltig zu begleiten.</P>
        <P $Blog>Auf Basis aktueller Erkenntnisse der Hirnforschung, Hypnose, systemischer und körperorientierter Ansätze nutze ich Methoden, die das Potential haben, kognitive und emotionale Blockaden zu lösen, um den Weg zu Ihren Ressourcen frei zu machen.</P>
        <P $Blog>Die Werte Achtsamkeit, Mitgefühl, Kreativität und Humor sind für mich die Grundlage meiner Arbeit.</P>
        <P $Blog>Ich lade Sie ein, sich beim Lesen meiner Seite einen ersten Eindruck von meinem Coachingangebot zu machen und freue mich darauf Sie persönlich kennenzulernen!
        In einem kostenfreien Erstgespräch am Telefon finden Sie und ich heraus, was Sie zu mir führt und wobei ich Sie unterstützen kann.</P>
    </BlogPost>
    

  </SectionBody>
</Section>

<Parallax bgImage={jpgPraxis2} strength={400} bgImageStyle={{ objectFit: 'cover' }}>
      <div className="h-screen/2">
      </div>
</Parallax>

<Section>
  <SectionBody>

    <Headline>
      <H1 $Center>Mögliche Themen</H1>
     
    </Headline>

    <Benefits>
      <Benefit>
        <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-primary-400 mb-5 flex-shrink-0 text-white"><Icon10 src={svgGem}/></div>
        <BenefitText>
          <H2>Ressourcen</H2>
            <P2>Sie wollen auf Ihre Ressourcen zugreifen können oder wollen für bestimmte Situationen Ihre Ressourcen verstärken, um einen Vortrag zu halten, eine Prüfung abzulegen oder sonstige Herausforderungen zu meistern?</P2>
        </BenefitText>
      </Benefit>
      <Benefit>
        <div style={{backgroundColor: 'RGB(69, 197, 202)'}} className="w-20 h-20 inline-flex items-center justify-center rounded-full mb-5 flex-shrink-0 text-white"><Icon10 src={svgCompass}/></div>
        <BenefitText>
          <H2>Orientierung</H2>
            <P2>Sie wollen Unterstützung bei Ihrer persönlichen Standortbestimmung in Ihrem Leben oder einem Lebensbereich, um Klarheit über Ihre Ziele und die nächsten Schritte auf Ihrem Weg zu bekommen?</P2>
        </BenefitText>
      </Benefit>
      <Benefit>
        <div style={{backgroundColor: 'RGB(92, 182, 213)'}} className="w-20 h-20 inline-flex items-center justify-center rounded-full mb-5 flex-shrink-0 text-white"><Icon10 src={svgGlasses}/></div>
        <BenefitText>
          <H2>Glaubenssätze</H2>
            <P2>Sie möchten an Ihren Überzeugungen arbeiten oder diese positiv verändern, um in Ihnen neue Möglichkeiten zu erschließen, von denen Sie eigentlich glauben, dass "das nicht funktioniert" oder Sie "nicht gut genug sind"?</P2>
        </BenefitText>
      </Benefit>
      <Benefit>
        <div style={{backgroundColor: 'RGB(116, 168, 224)'}} className="w-20 h-20 inline-flex items-center justify-center rounded-full mb-5 flex-shrink-0 text-white"><Icon10 src={svgCard}/></div>
        <BenefitText>
          <H2>Gewohnheiten</H2>
            <P2>Sie möchten unvorteilhafte oder lästige Gewohnheiten verändern oder ablegen, die mittlerweile überholt sind und Sie auf lästige Weise weiterhin begleiten und stören?</P2>
        </BenefitText>
      </Benefit>
      <Benefit>
        <div style={{backgroundColor: 'RGB(139, 153, 235)'}} className="w-20 h-20 inline-flex items-center justify-center rounded-full mb-5 flex-shrink-0 text-white"><Icon10 src={svgSpider}/></div>
        <BenefitText>
          <H2>Ängste</H2>
            <P2>Sie würden gerne von Ängsten und den damit verbundenen Emotionen befreit sein oder diesen Gefühlen die Intensität nehmen? Unangenehme Gefühle vor bestimmten Situationen oder Objekten, wie z.B. Spinnen, möchten Sie gerne auflösen?</P2>
        </BenefitText>
      </Benefit>
      <Benefit>
        <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-secondary-400 mb-5 flex-shrink-0 text-white"><Icon10 src={svgBolt}/></div>
        <BenefitText>
          <H2>Stress</H2>
            <P2>In Ihrem Leben ist der Stress belastend geworden und beansprucht Sie sogar in Situationen, die eigentlich völlig stressfrei und entspannt sein könnten? Ihre Gedanken kreisen um das stressbesetzte Thema und Sie kommen gar nicht mehr richtig zur Ruhe.</P2>
        </BenefitText>
      </Benefit>    

    </Benefits>

  </SectionBody>
</Section>


<Section $greyBg>
  <SectionBody>
    <BlogPost className="text-justify w-full mb-12">
      <H1 $Center>Für wen und wann kann ein <HL>Coaching</HL><br/> hilfreich sein?</H1>
        <P $Blog>Wenn Sie sich weiterentwickeln wollen, etwas in Ihrem Leben ändern, Klarheit gewinnen möchten oder sich in einer Krise befinden - dann kann ein Coaching sinnvoll sein. Ob es um berufliche Neuorientierung, lästige Angewohnheiten, ein Gefühl der Überforderung oder etwas anderes geht: Die innere Motivation einen Schritt zu machen und sich zu bewegen, ist die beste Voraussetzung um in kurzer Zeit große Schritte zu machen.</P>
    </BlogPost>
    
    <QuoteBg style={{backgroundImage: 'url('+bgQuote03+')',backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}}>
      <QuoteWrapper >
        <QuoteText>»Probleme können nicht mit demselben Bewusstsein gelöst werden in dem sie entstanden sind.«</QuoteText>
          <QuoteSeperator ></QuoteSeperator><QuoteName>Albert Einstein</QuoteName><QuoteTitel>Physiker</QuoteTitel>
      </QuoteWrapper>
    </QuoteBg>

  </SectionBody>
</Section>


<Parallax bgImage={jpgNeuronen} strength={300} bgImageStyle={{ objectFit: 'cover' }}>
      <div className="h-screen/2"></div>
</Parallax>

  <Section $greyBg>
    <Hero $Right>
      <HeroTextSpan $Right>
        <H1>Neuro-Coaching</H1>
          <P>Neurocoaching ist ein Sammelbegriff für verschiedene Techniken, die das Nervensystem einbeziehen und gezielt darauf einwirken. <br/>Aussagen oder imaginierte Bilder lösen Reaktionen z.B. in Form von Anspannung aus. Stress und stressbeladene Themen können erkannt werden, sogar wenn sie dem/der Klient/in nicht vollständig bewusst sind. Durch gezielte Interventionen können diese Stressreaktionen verändert und eine deutliche Erleichterung im Umgang mit bis dahin bestehenden stressbeladenen Themen erreicht werden.</P>
          <CTA>
           <a href="/neurocoaching"><Button>Mehr</Button></a>
          </CTA>
      </HeroTextSpan>
      <HeroImageSpan>
        <img className="object-cover object-center rounded filter mix-blend-multiply" alt="hero" src={jpgBrain} />
      </HeroImageSpan>
    </Hero>
    <div></div>
  </Section>

  <Section id="supervision">
    <Hero>
      <HeroImageSpan>
        <img className="object-cover object-center rounded" alt="hero" src={jpgSupervision} />
      </HeroImageSpan>
      <HeroTextSpan>
        <H1>Supervision & Teambuilding</H1>
          <P>Haben Sie in einer Gruppe bzw. Ihrem Kollegium eine herausfordernde Situation, deren Klärung und Lösung von innen heraus viel Kraft kostet? Alle Mühen die Situation zu verbessern waren bisher nicht zielführend. Belasten zwischenmenschliche Konflikte das Arbeitsklima?</P>
          <P>Wie beim Autofahren gibt es in (Arbeits-)Beziehungen tote Winkel, die eine klare Sicht auf die mögliche Lösung erschweren bis unmöglich machen. Hier kann es hilfreich sein einen professionellen Blick von außen zu nutzen. Unvoreingenommen und emotional nicht involviert zu sein, macht es leichter die einzelnen Beteiligten und die ganze Gruppe zu unterstützen, Dinge aus einer neuen Perspektive zu sehen. So kann eine tragfähige, gemeinsame Lösung entstehen!</P>
          <P>Brauchen Sie einfach einen Impuls um Dinge in eine gute Richtung zu bringen? Dann kann eine Supervision oder ein Teambuilding das Richtige für Sie sein!</P>
          <P>In einem Vorgespräch schildern Sie mir Ihr Anliegen und den Kontext der aktuellen Unternehmenssituation. Sie und ich ermitteln gemeinsam den Bedarf und definieren ein Ziel für die Supervision.</P>
          <P>Melden Sie sich gerne wenn Sie das Gefühl haben, dass ich für Sie als Impulsgeber und Prozessbegleiter eine gute Unterstützung sein kann!</P>

      </HeroTextSpan>
    </Hero>
  </Section>

  <Section id="naturcoaching" $greyBg>
    <Hero $Right>
      <HeroTextSpan $Right>
        <H1>Stressmanagement & Stressprävention</H1>
          <P>Stress ist eine evolutionär alte Anpassungsreaktion auf eine (potentielle) Gefahr, die unseren Organismus für Flucht oder Kampf bereitmacht. Diese Anpassungsreaktion ist ein Grund, dass wir als Menschen heute existieren, da unsere Vorfahren es durch sie geschafft haben, auf gefährliche und lebensbedrohliche Situationen zu reagieren und sie zu überstehen.</P>
          <P>In unserer heutigen Welt sind lebensbedrohliche Gefahren die Ausnahme. So wie für unsere Vorfahren der Säbelzahntiger eine konkrete Bedrohung darstellte, sind es heute jedoch andere Ursachen, die zu einer solchen Reaktion führen.</P>
          <P>Der Säbelzahntiger kann heute in Gestalt von Erwartungen, die zu erfüllen sind, Anforderungen, die zu bestehen sind oder Sorgen, die sich im Kreis drehen, auftauchen. Egal ob im Job, in der Schule bis in den privaten Bereich: Von finanziellen Sorgen, über den Vorgesetzten, den man nicht enttäuschen will oder der Prüfung, durch die man nicht durchfallen darf - auch wenn es nicht lebensbedrohlich ist: Die Stressreaktion ist in ihrer Weise dieselbe!</P>
          <P>Damit ist die Stressreaktion, die früher unser Überleben gesichert hat, heute zum Faktor geworden, der unsere Gesundheit bedrohen kann.</P>
          <P>Da langfristiger Stress ein großes Risiko für die mentale und körperliche Gesundheit darstellt, ist es gesund, wieder in einen Zustand der Regeneration zu gelangen. Als ausgebildeter Stressmanagement-Coach unterstütze ich Sie dabei gerne!</P>

        <CTA>
          <Button $Second>Kontakt</Button>
        </CTA>
      </HeroTextSpan>
      <HeroImageSpan >
        <img className="object-cover object-center rounded" alt="hero" src={pngBurnout} />
      </HeroImageSpan>
    </Hero>
  </Section>

  <Parallax bgImage={jpgWald} strength={300} bgImageStyle={{ objectFit: 'cover' }}>
        <div className="h-screen/2"></div>
  </Parallax>

  <Section id="me"> 
    <Hero $Right>
      <HeroTextSpan $Right>
        <H1>Über <HL>Mich</HL></H1>
          <P><b>Andreas Ochsmann, geb. 1980</b></P>
          <P>Meine Liebe zur Natur hat mich im Alter von 20 Jahren zunächst zu Lehrern verschiedener Naturvölker geführt von denen ich viele Jahre über die Bedeutung von Natur, Kultur, Traditionen - und über mich selbst gelernt habe. Diese langjährige Verbindung und Lehrzeit hat mir geholfen, die Welt mit anderen Augen zu sehen und vieles neu zu entdecken.</P>
          <P>Eine therapeutische Ausbildung und die langjährige Arbeit in dem Bereich hat es mir ermöglicht Menschen in allen Altersgruppen und in unterschiedlichsten Lebenslagen zu begleiten. Durch diese Tätigkeit habe ich viel über existenzielle Schwierigkeiten und Herausforderungen von Menschen und deren Bedeutung als Hürde für ein zufriedenes Leben erfahren und gelernt.</P>
          <P>Bei verschiedenen Lehrern und Ausbildern in Deutschland und den USA habe ich meine Methodenvielfalt Schritt für Schritt erweitert und unterschiedlichste Sichtweisen zur Persönlichkeitsentwicklung kennengelernt: Von systemischem Coaching über Hypnose und körperorientierte Verfahren.</P>
          <P>Als zertifizierter Coach (Leibniz Universität Hannover) kombiniere ich heute verschiedene Methoden, um individuell Veränderung zu unterstützen, die nachhaltig ist. Dadurch wird meine Arbeit immer mehr zu dem, was ich mir unter erfolgreichem Coaching vorstelle: In kurzer Zeit deutlich wahrnehmbare Resultate zu erzielen. Im Kern geht es mir darum Menschen zu ermöglichen, die Person zu werden, die sie wirklich sind.</P>
      </HeroTextSpan>
      <HeroImageSpan>
        <img className="rounded h-screen/2 object-cover object-center" alt="Andreas Ochsmann - Coach" title="Andreas Ochsmann - Coach" src={jpgPortrait} />
      </HeroImageSpan>
    </Hero>
  </Section>

  <Contactform/>
  <Footer/>
</div>

  );
}

export default Home;


